"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var S = __importStar(require("./stream"));
var Sink = __importStar(require("./sink"));
var Q = __importStar(require("../queue"));
var T = __importStar(require("../effect"));
var M = __importStar(require("../managed"));
var Option_1 = require("fp-ts/lib/Option");
var pipeable_1 = require("fp-ts/lib/pipeable");
var Do_1 = require("fp-ts-contrib/lib/Do");
var support_1 = require("./support");
function subject(_) {
    var listeners = new Map();
    function next(_) {
        listeners.forEach(function (f) {
            f(_);
        });
    }
    return Do_1.Do(T.effect)
        .bind("q", Q.unboundedQueue())
        .bindL("into", function (_a) {
        var q = _a.q;
        return pipeable_1.pipe(_, S.into(Sink.queueOptionSink(q)), T.chainError(function (e) {
            return pipeable_1.pipe(T.sync(function () {
                next({ _tag: "error", e: e });
            }), T.chain(function () { return T.raiseError(e); }));
        }), T.fork);
    })
        .bindL("extract", function (_a) {
        var q = _a.q;
        return pipeable_1.pipe(q.take, T.chainTap(function (_) {
            return T.sync(function () { return next(Option_1.isSome(_) ? { _tag: "offer", a: _.value } : { _tag: "complete" }); });
        }), T.forever, T.fork);
    })["return"](function (_a) {
        var into = _a.into, extract = _a.extract;
        var interrupt = pipeable_1.pipe(T.sequenceT(into.interrupt, extract.interrupt, T.sync(function () {
            next({ _tag: "complete" });
        })), T.asUnit);
        var subscribe = T.sync(function () {
            var _a = support_1.queueUtils(), next = _a.next, ops = _a.ops, hasCB = _a.hasCB;
            var push = function (_) {
                next(_);
            };
            listeners.set(push, push);
            return S.fromSource(pipeable_1.pipe(M.bracket(T.unit, function () {
                return T.sync(function () {
                    listeners["delete"](push);
                });
            }), M.chain(function () { return support_1.emitter(ops, hasCB); })));
        });
        return {
            interrupt: interrupt,
            subscribe: subscribe
        };
    });
}
exports.subject = subject;
